var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h20v20H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M18 7.057h-4.569V0H6.57v7.057H1.999l8.002 8.235L18 7.057zM1.999 17.646V20H18v-2.354H1.999z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownloadIcon);
export default __webpack_public_path__ + "static/media/black-download-icon.05f588544d5b8ee43ea9138c4af94e43.svg";
export { ForwardRef as ReactComponent };